// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import Svg, { SvgProps } from '../Svg';

const Play: React.SFC<SvgProps> = props => (
  <Svg {...props}>
    <path d="M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm-1.342 3.803c.402-.211.89-.181 1.265.083l3.02 2.113c.325.229.52.603.52 1 0 .4-.195.774-.52 1.002l-3.02 2.114c-.21.147-.455.22-.7.22-.194 0-.387-.045-.565-.137-.406-.211-.658-.627-.658-1.084V9.887c0-.457.252-.873.658-1.084zm.565.86c-.043 0-.08.014-.103.027-.045.023-.12.08-.12.197v4.227c0 .117.075.173.12.197.044.024.135.05.228-.015l3.02-2.113c.082-.058.095-.14.095-.183 0-.043-.013-.125-.095-.182l-3.02-2.114c-.043-.03-.086-.041-.125-.041z"/>
  </Svg>
);

Play.displayName = "Play";

export default Play;
